/** Legacy Book PDF export entitlement helpers — UI only (Stage 4B.4). */

export function getExportButtonLabel(entitlement) {
  if (!entitlement?.enforcement_enabled) {
    return 'Export';
  }
  if (entitlement.export_mode_hint === 'preview') {
    return 'Preview export';
  }
  if (entitlement.export_mode_hint === 'upgrade') {
    return 'Reserve founding offer';
  }
  return 'Export';
}

export function getExportHelperCopy(entitlement) {
  if (!entitlement?.enforcement_enabled) {
    return null;
  }
  if (entitlement.export_mode_hint === 'preview') {
    return 'Full keepsake export is part of the Legacy Book founding offer.';
  }
  if (entitlement.export_mode_hint === 'upgrade') {
    return 'Full keepsake export is part of the Legacy Book founding offer.';
  }
  return null;
}

export function shouldShowExportUpgradeCopy(entitlement) {
  if (!entitlement?.enforcement_enabled) {
    return false;
  }
  return Boolean(
    entitlement.upgrade_recommended
    || entitlement.export_mode_hint === 'preview'
    || entitlement.export_mode_hint === 'upgrade'
  );
}

export function isPreviewWatermarkedExport(entitlement) {
  return Boolean(entitlement?.should_watermark_pdf);
}

export function exportActionIsLink(entitlement) {
  return entitlement?.enforcement_enabled && entitlement?.export_mode_hint === 'upgrade';
}
